import { z } from 'zod'

/** メニュー項目の種別（バックエンド MenuItemType enum に対応） */
export const MenuItemTypeSchema = z.enum(['URL', 'STATIC', 'SNS'])
export type MenuItemType = z.infer<typeof MenuItemTypeSchema>

/** URL タイプ: カスタムリンク（url 必須） */
const UrlMenuDataSchema = z.object({
  name: z.string(),
  type: z.literal('URL'),
  url: z.string(),
  action: z.string().nullable(),
})

/** STATIC action 値（バックエンド ListMenusUseCase に対応） */
export const StaticActionSchema = z.enum([
  'PRODUCT_LIST',
  'FAQ',
  'TERMS',
  'PRIVACY_POLICY',
  'TOKUSHOHO',
  'RESET',
  'RESTORE',
  'ACCOUNT_PASSWORD', // パスワード変更（#3616）。auth の /{campaignSlug}/account/password をフロントで組み立てる
  'LOGOUT',
  'CONTACT',
])
export type StaticAction = z.infer<typeof StaticActionSchema>

/** STATIC タイプ: 固定メニュー（action 必須） */
const StaticMenuDataSchema = z.object({
  name: z.string(),
  type: z.literal('STATIC'),
  url: z.string().nullable(),
  action: StaticActionSchema,
})

/** SNS action 値（バックエンド OfficialSnsType enum に対応） */
export const SnsActionSchema = z.enum(['facebook', 'instagram', 'x', 'line', 'tiktok'])
export type SnsAction = z.infer<typeof SnsActionSchema>

/** SNS タイプ: SNS リンク（url, action 必須） */
const SnsMenuDataSchema = z.object({
  name: z.string(),
  type: z.literal('SNS'),
  url: z.string(),
  action: SnsActionSchema,
})

export const MenuDataSchema = z.discriminatedUnion('type', [UrlMenuDataSchema, StaticMenuDataSchema, SnsMenuDataSchema])

export const MenuListResponseSchema = z.object({
  menus: z.array(MenuDataSchema),
})

export type MenuData = z.infer<typeof MenuDataSchema>
export type MenuListResponse = z.infer<typeof MenuListResponseSchema>
